module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/wi-fi-776635d64393d2d09d06bcaf60bdbfc3.svg";